import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/calls/team-presence')({
  staticData: { team: 'fe-phone-experience' },
});
